(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('ordersService', order);

    order.$inject = [
        '$http',
        '$q',
        'endPoints',
        'authorization',
        '$filter'
    ];

    function order(
        $http,
        $q,
        endPoints,
        authorization,
        $filter
    ) {

        var service = {
            getAllOrders: getAllOrders,
            getScheduledOrders: getScheduledOrders,
            activateScheduledOrder: activateScheduledOrder,
            activateScheduledOrders: activateScheduledOrders,
            getOrderById: getOrderById,
            getOrderLogById: getOrderLogById,
            saveOrder: saveOrder,
            saveOrdenLinea: saveOrdenLinea,
            addOrder: addOrder,
            addOrderLog: addOrderLog,
            deleteOrderLog: deleteOrderLog,
            updateOrderLog: updateOrderLog,
            assignToOperator: assignToOperator,
			getLogOrders: getLogOrders,
			setEstadoAsignacionOrder: setEstadoAsignacionOrder,
			getLogInternalOrders: getLogInternalOrders,
			getLogInternalNewOrders: getLogInternalNewOrders,
            legacyChangeAssignmentState: legacyChangeAssignmentState,
            legacyChangeOrderState: legacyChangeOrderState,
            acknowledgeDelay: acknowledgeDelay,
            retarifar: retarifar,
            calcular: calcular,
            removeOrdenLinea: removeOrdenLinea,
            getOrdenLineas: getOrdenLineas,
            getOrdenImagenes: getOrdenImagenes,
            removeOrders: removeOrders,
            getLineasImpuesto: getLineasImpuesto,
            getLogPlannerOrders: getLogPlannerOrders,
            getLogPlannerOrdersDiv: getLogPlannerOrdersDiv,
            splitOrder: splitOrder,
            joinOrder: joinOrder,
			changeAssignmentState: changeAssignmentState,

        };

        return service;

        function legacyChangeOrderState(orderId, state) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.changeState,
                data: { 'token': authorization.getStoredToken(), 'orderId': orderId, 'state': state },
                headers: {
                    'authorization': undefined
                }
            };
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function calcular(orderId, dto, supIncFac) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.calcular,
                data: {
                    'token': authorization.getStoredToken(),
                    'orderId': orderId,
                    'dto': dto,
                    'suplidos': supIncFac === true
                },
                headers: {
                    'authorization': undefined
                }
            };

            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function retarifar(orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.retarifar,
                data: { 'token': authorization.getStoredToken(), 'orderId': orderId },
                headers: {
                    'authorization': undefined
                }
            };
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function legacyChangeAssignmentState(orderId, state, tiempoDemora, idRechazo, extraParams) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.changeAssignmentState,
                data: {
                    'token': authorization.getStoredToken(),
                    'orderId': orderId,
                    'estadoAsignacion': state,
                    'idRechazo': idRechazo,
                    'tiempoDemora': tiempoDemora,
                    'extraparams': extraParams
                },
                headers: {
                    'authorization': undefined
                }
            };
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function changeAssignmentState(orderId, state) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.updateAssignmentState + '?orderId=' + orderId + '&state=' + state
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getAllOrders(skip, take, sorting, filters, baja, frequencyFields, searchText, programadas, fromDate, toDate) {
            var deferred = $q.defer();
            var dateParams = '&fromDate=' + ((fromDate) ? fromDate.format('YYYY-MM-DD') : '') + '&toDate=' + ((toDate) ? toDate.format('YYYY-MM-DD') : '');
            var request = {
                method: 'POST',
                url: endPoints.orders.getOrders + 'GetAll' + '?skip=' + skip + '&take=' + take + dateParams,
                data: {
                    'sorting': sorting,
                    'filters': filters,
                    'dadosDeBaja': baja,
                    'programadas': programadas,
                    'frequencyFields': frequencyFields,
                    'searchTextByFrequencyFields': searchText
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getScheduledOrders() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.orders.getScheduledOrders
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
                function (response) {
                    deferred.reject(null);
                });

            return deferred.promise;
        }

        function activateScheduledOrder(orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.activateScheduledOrder,
                data: {
                    'orderId': orderId
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            }, function (response) {
                deferred.reject(null);
            });

            return deferred.promise;
        }

        function activateScheduledOrders(orderIds) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.activateScheduledOrders,
                data: {
                    'orderIds': orderIds
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            }, function (response) {
                    deferred.reject(null);
                });

            return deferred.promise;
        }

        function getLogPlannerOrders(skip, take, sorting, filters, baja, frequencyFields, searchText, fromDate, toDate) {
            var deferred = $q.defer();
            var dateParams = '&fromDate=' + ((fromDate) ? fromDate.format('YYYY-MM-DD') : '') + '&toDate=' + ((toDate) ? toDate.format('YYYY-MM-DD') : '');
            var request = {
                method: 'POST',
                url: endPoints.orders.getLogPlanner + '?skip=' + skip + '&take=' + take + dateParams,
                data: {
                    'sorting': sorting, 'filters': filters, 'dadosDeBaja': baja,
                    'frequencyFields': frequencyFields, 'searchTextByFrequencyFields': searchText
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getLogPlannerOrdersDiv(skip, take, sorting, filters, baja, frequencyFields, searchText, fromDate, toDate) {
            var deferred = $q.defer();
            var dateParams = '&fromDate=' + ((fromDate) ? fromDate.format('YYYY-MM-DD') : '') + '&toDate=' + ((toDate) ? toDate.format('YYYY-MM-DD') : '');
            var request = {
                method: 'POST',
                url: endPoints.orders.getLogPlannerDiv + '?skip=' + skip + '&take=' + take + dateParams,
                data: {
                    'sorting': sorting, 'filters': filters, 'dadosDeBaja': baja,
                    'frequencyFields': frequencyFields, 'searchTextByFrequencyFields': searchText
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getLogOrders(skip, take, sorting, filters, frequencyFields, searchText, fromDate, toDate, minState, maxState) {
            var deferred = $q.defer();
			var dateParams = '&fromDate=' + ((fromDate) ? fromDate.format('YYYY-MM-DD') : '') + '&toDate=' + ((toDate) ? toDate.format('YYYY-MM-DD') : '');
            var request = {
                method: 'POST',
				url: endPoints.orders.getOrders + 'getlogistic' + '?skip=' + skip + '&take=' + take + dateParams + '&minState=' + minState + '&maxState=' + maxState,
                data: {
                    'sorting': sorting, 'filters': filters,
                    'frequencyFields': frequencyFields, 'searchTextByFrequencyFields': searchText
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
		}

		function setEstadoAsignacionOrder(orderId, estadoAsignacion) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.orders.getOrders + 'SetEstadoAsignacionOrder' + '?orderId=' + orderId + '&estadoAsignacion=' + estadoAsignacion
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}
		

        function getLogInternalOrders(orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.orders.getOrders + 'GetOrdersForLog' + '?orderId=' + orderId
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
		}

		function getLogInternalNewOrders(orderId) {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.orders.getOrders + 'GetNewOrdersForLog' + '?orderId=' + orderId
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

        function getOrderById(orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.orders.getOrders + ('getById?orderId=' + orderId)
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getOrderLogById(orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.orders.getOrders + ('getOrdenLogById?orderId=' + orderId)
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function saveOrder(order, orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'PUT',
                url: endPoints.orders.getOrders + 'update' + '?orderId=' + orderId,
                data: order
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getOrdenImagenes(orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.orders.getOrdenImagenes + '?orderId=' + orderId
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getOrdenLineas(orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.orders.getOrdenLineas + '?orderId=' + orderId
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getLineasImpuesto(orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.orders.getLineasImpuesto + '?orderId=' + orderId
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function saveOrdenLinea(ordenLinea) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.addOrdenLinea,
                data: ordenLinea
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function removeOrdenLinea(ordenLineaId) {
            var deferred = $q.defer();
            var request = {
                method: 'DELETE',
                url: endPoints.orders.removeOrdenLinea + '?ordenLineaId=' + ordenLineaId,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function removeOrders(ordenIds) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.removeOrders,
                data: ordenIds
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function addOrder(order) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.getOrders + 'add',
                data: order
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function addOrderLog(order) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.getOrders + 'addLogistica',
                data: order
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function deleteOrderLog(orders) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.getOrders + 'deleteLogistica',
                data: orders
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function updateOrderLog(order, orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'PUT',
                url: endPoints.orders.getOrders + 'updateLogistica' + '?orderId=' + orderId,
                data: order
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function assignToOperator(operatorId, orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.assignToOperator,
                data: { orderId: orderId, operatorId: operatorId }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function acknowledgeDelay(orderId) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.acknowledgeDelay + '?orderId=' + orderId
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }


        function splitOrder(orderId, parada) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.splitOrder + '?orderId=' + orderId,
                data: parada
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function joinOrder(orderId1, orderId2) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.orders.joinOrder + '?orderId1=' + orderId1 + '&orderId2=' + orderId2
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }
    }
})();